import { defineStore } from 'pinia'
import { ArrayComparator } from "@/libs/array_compactor"
import {EventsList} from "@/store/wp_planner/events.store";
import {CurrentPeriod} from "@/store/wp_planner/main.store";
import moment from "moment";

export const Mai_Documents = defineStore({
    id: 'wp_docs__maintenance',
    state: () => {
        return { value: [] }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        },
        async update(token, district, year, week) {
            let url = `${window.config.SSL}://${window.config.ONEADDRESS}/${window.config.BASE}/${window.config.API_VERSION}/wp/documents/maintenance`
            let data = JSON.stringify({
                "year": year,
                "week": week,
                "district": district
            })
            let meta = {
                method: 'POST',
                withCredentials: true,
                headers: {
                    "Authorization": "Bearer " + token
                },
                body: data
            }
            fetch(url, meta)
                .then(response => response.json())
                .then((data => {
                    if (data) {
                        let actions = ArrayComparator(this.value, data.documents)

                        actions.inserted.map(el => {
                            this.value.push(el)
                        })

                        actions.deleted.map(el => {
                            let index = this.value.indexOf(this.value.find(doc => doc.guid === el.guid))
                            this.value.splice(index, 1)
                        })

                        actions.updated.map(el => {
                            let index = this.value.indexOf(this.value.find(doc => doc.guid === el.guid))
                            Object.keys(this.value[index]).map(field => {
                                if (this.value[index][field] !== el[field]) {
                                    this.value[index][field] = el[field]
                                }
                            })
                        })

                        let current_week = CurrentPeriod().get()
                        for (let ev of EventsList().get()) {
                            if (this.value.filter(doc => doc.guid === ev.guid).length > 0) {
                                if (moment(ev.date.desire).startOf('day')  >= current_week.startOf('day')) {
                                    this.value.splice(this.value.findIndex(el => el.guid === ev.guid), 1)
                                }
                            }
                        }
                    }
                }))
                .catch(err => {
                    console.error(err)
                })
        }
    },
})
